export default "__VITE_ASSET__be771aca__"